import { Inbox, TriangleAlert } from 'lucide-react';
import { Spinner } from '@/ui/components/ui/spinner';
import { StatusPlaceholder } from '@/ui/components/ui/status-placeholder';
import type { Feature } from '../types/feature.types';
import { FeatureCard } from './feature-card';

interface FeatureListProps {
	loading: boolean;
	error: boolean;
	features: Feature[];
	poppedId: string | null;
	newId: string | null;
	onVote: (id: string) => void;
	onRef: (id: string, el: HTMLDivElement | null) => void;
}

export function FeatureList({
	loading,
	error,
	features,
	poppedId,
	newId,
	onVote,
	onRef,
}: FeatureListProps) {
	if (loading) {
		return (
			<div className='flex items-center justify-center py-16'>
				<Spinner size='lg' />
			</div>
		);
	}

	if (error) {
		return (
			<StatusPlaceholder
				icon={TriangleAlert}
				title='Failed to load feature requests'
				description='Something went wrong. Please try again later.'
				variant='error'
			/>
		);
	}

	if (features.length === 0) {
		return (
			<StatusPlaceholder
				icon={Inbox}
				title='No feature requests'
				description='Feature requests submitted by users will appear here.'
			/>
		);
	}

	return (
		<div className='flex flex-col gap-2'>
			{features.map((f) => (
				<FeatureCard
					key={f.id}
					feature={f}
					isPopping={poppedId === f.id}
					isNew={newId === f.id}
					onVote={onVote}
					onRef={(el) => onRef(f.id, el)}
				/>
			))}
		</div>
	);
}
